import {
  fetchClasses,
  editClass,
  createClass,
  deleteClass,
  fetchTeacherClasses,
} from "./asyncThunks";

export const fetchClassesBuilder = (builder) => {
  builder.addCase(fetchClasses.pending, (state) => {
    state.fetchClassesPending = true;
  });
  builder.addCase(fetchClasses.fulfilled, (state, action) => {
    state.fetchClassesPending = false;
    state.classes.data = action.payload.data;
  });
  builder.addCase(fetchClasses.rejected, (state) => {
    state.fetchClassesPending = false;
  });
};

export const fetchTeacherClassesBuilder = (builder) => {
  builder.addCase(fetchTeacherClasses.fulfilled, (state, action) => {
    state.classes.teacherClasses = action.payload.data.teacherClasses;
  });
};

export const createClassBuilder = (builder) => {
  builder.addCase(createClass.pending, (state) => {
    state.createClassPending = true;
  });
  builder.addCase(createClass.fulfilled, (state, action) => {
    state.createClassPending = false;
    state.classes.data.classes = [
      action.payload.data.class,
      ...state.classes.data.classes,
    ];
  });
  builder.addCase(createClass.rejected, (state) => {
    state.createClassPending = false;
  });
};

export const editClassBuilder = (builder) => {
  builder.addCase(editClass.pending, (state) => {
    state.editClassPending = true;
  });
  builder.addCase(editClass.fulfilled, (state, action) => {
    state.editClassPending = false;

    state.classes.data.classes = state.classes.data.classes.map((s) => {
      if (s.classId === action.payload.data.class.classId) {
        return action.payload.data.class;
      } else {
        return s;
      }
    });
  });
  builder.addCase(editClass.rejected, (state) => {
    state.editClassPending = false;
  });
};

export const deleteClassBuilder = (builder) => {
  builder.addCase(deleteClass.pending, (state) => {
    state.deleteClassPending = true;
  });
  builder.addCase(deleteClass.fulfilled, (state, action) => {
    state.deleteClassPending = false;
    state.classes.data.classes = state.classes.data.classes.filter(
      (s) => s.classId !== action.payload.data.classId
    );
  });
  builder.addCase(deleteClass.rejected, (state) => {
    state.deleteClassPending = false;
  });
};
